import FolderContentToolbar from './folderContentToolbar';
import { connect } from 'redhooks';
import { navViewFolder } from '../../../../nav/nav.actions';

export default connect(null, { navViewFolder })(FolderContentToolbar);